module.exports = "body {\n  background-image: 'https://i.pinimg.com/originals/0a/b7/aa/0ab7aa93898f6530edb7b583bc400873.jpg';\n  background-color: rgba(255,255,255,0.6);\n  background-blend-mode: lighten;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main